"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Companies = exports.ButtonText = exports.FreeCredit3 = exports.FreeCredit2 = exports.FreeCredit1 = exports.FreeCredit = exports.BottomCTA = exports.FeaturesWrapper = exports.TestimonialsWrapper = exports.Content = exports.Boxes = exports.Hero = exports.Headline = exports.Wrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importStar(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const elements_1 = require("@src/components/elements");
const CompaniesListPreview_1 = require("@src/components/modules/global/CompaniesList/CompaniesListPreview");
const BoxFree_1 = require("./BoxFree");
const BoxCredits_1 = require("./BoxCredits");
const Testimonials_1 = require("./Testimonials");
const Features_1 = require("./Features");
const Companies = () => {
    const theme = (0, styled_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(exports.Wrapper, { children: [(0, jsx_runtime_1.jsx)(exports.Hero, { children: (0, jsx_runtime_1.jsx)(elements_1.Holder, { children: (0, jsx_runtime_1.jsxs)(exports.Headline, { children: [(0, jsx_runtime_1.jsx)("h1", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.headline" }) }), (0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.subheadline_1" }) })] }) }) }), (0, jsx_runtime_1.jsxs)(exports.Content, { children: [(0, jsx_runtime_1.jsx)(elements_1.Holder, { children: (0, jsx_runtime_1.jsxs)(exports.Boxes, { children: [(0, jsx_runtime_1.jsx)(BoxFree_1.BoxFree, {}), (0, jsx_runtime_1.jsx)(BoxCredits_1.BoxCredits, {})] }) }), (0, jsx_runtime_1.jsx)(CompaniesListPreview_1.CompaniesListPreview, {}), (0, jsx_runtime_1.jsx)(exports.FeaturesWrapper, { id: "features", children: (0, jsx_runtime_1.jsxs)(elements_1.Holder, { children: [(0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.headilne" }) }), (0, jsx_runtime_1.jsx)(Features_1.Features, {})] }) }), (0, jsx_runtime_1.jsx)(exports.TestimonialsWrapper, { children: (0, jsx_runtime_1.jsxs)(elements_1.Holder, { children: [(0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.testimonials.headilne" }) }), (0, jsx_runtime_1.jsx)(Testimonials_1.Testimonials, {})] }) }), (0, jsx_runtime_1.jsx)(exports.BottomCTA, { children: (0, jsx_runtime_1.jsxs)(elements_1.Holder, { children: [(0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.results.headilne" }) }), (0, jsx_runtime_1.jsxs)(exports.FreeCredit, { children: [(0, jsx_runtime_1.jsx)(elements_1.Button, { style: {
                                                background: theme.color.success,
                                                borderColor: theme.color.success,
                                                color: theme.color.white,
                                            }, link: "/registracia", children: (0, jsx_runtime_1.jsx)(exports.ButtonText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.free.create_account_free" }) }) }), (0, jsx_runtime_1.jsx)(exports.FreeCredit3, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.free.no_hidden_fees" }) })] })] }) })] })] }));
};
exports.Companies = Companies;
exports.Wrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	background: ${({ theme }) => theme.color.gray2};
`;
exports.Headline = styled_components_1.default.div `
	position: relative;
	z-index: 1;
	text-align: center;
	padding: 3.5em 2em 0;

	${(0, styled_breakpoints_1.up)('sm')} {
		padding: 2.5em 2em 0;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		padding: 5em 2em 0;
	}

	& > * {
		color: ${props => props.theme.color.white};
	}
	h1 {
		font-size: 2.4em;
		font-weight: bold;
		margin-bottom: 0.5em;
	}
	h2 {
		font-size: 1.4em;
		font-weight: 200;
		line-height: 1.4;
	}
`;
exports.Hero = styled_components_1.default.div `
	padding-top: ${props => props.theme.size.headerHeight}px;
	padding-bottom: 4rem;
	width: 100%;
	position: relative;
	background: url('/media/images/hero-company3.jpg');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center 0;

	${(0, styled_breakpoints_1.up)('sm')} {
		padding-bottom: 6rem;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		padding-bottom: 8rem;
	}

	&:after {
		content: '';
		display: block;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		position: absolute;
		z-index: 0;
		pointer-events: none;
		opacity: 0.95;
		background: url('/media/images/background-gradient.jpg');
		background-repeat: no-repeat;
		background-size: cover;
	}
`;
exports.Boxes = styled_components_1.default.div `
	width: 100%;
	position: relative;
	z-index: 1;
	display: flex;
	align-items: flex-start;
	margin-top: 2rem;
	flex-direction: column;

	${(0, styled_breakpoints_1.up)('sm')} {
		margin-top: 3rem;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		justify-content: center;
		flex-direction: row;
		margin-top: 4rem;
	}
`;
exports.Content = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
exports.TestimonialsWrapper = styled_components_1.default.div `
	width: 100%;

	padding: 5em 0;

	h2 {
		color: ${props => props.theme.color.brand4};
		font-size: 2em;
		text-align: center;
		font-weight: 700;
		margin: 0 0 2em;
	}
`;
exports.FeaturesWrapper = styled_components_1.default.div `
	width: 100%;
	background: ${props => props.theme.color.white};
	padding: 5em 0 2em;

	h2 {
		color: ${props => props.theme.color.brand4};
		font-size: 2em;
		text-align: center;
		font-weight: 700;
		margin: 0 0 2em;
	}
`;
exports.BottomCTA = styled_components_1.default.div `
	width: 100%;
	background: ${props => props.theme.color.white};
	padding: 5em 0;
	text-align: center;

	p strong {
		color: ${props => props.theme.color.brand2};
	}

	h2 {
		color: ${props => props.theme.color.brand4};
		font-size: 2em;
		font-weight: 700;
		margin: 0 0 0.5em;
	}
`;
exports.FreeCredit = styled_components_1.default.div `
	width: 100%;
	padding: 0 0 2em 0;
	text-align: center;
`;
exports.FreeCredit1 = styled_components_1.default.div `
	width: 100%;
	padding: 1em 3em 0;
	font-weight: 700;
`;
exports.FreeCredit2 = styled_components_1.default.div `
	font-size: 2em;
	font-weight: 700;
	padding: 0.3em 1em 1em;
	color: ${props => props.theme.color.brand3};
`;
exports.FreeCredit3 = styled_components_1.default.div `
	width: 100%;
	font-weight: 400;
	font-size: 0.9em;
	padding: 1em 3em 0;
	color: ${props => props.theme.color.gray6};
`;
exports.ButtonText = styled_components_1.default.div ``;
